import { newServiceBadge, officialPartnerBadge, profitableOfferBadge } from '../config/infoCards'

interface GetTspBadgesByServiceArgs {
  showVouchersForm: boolean
  tspUrl: string
}

export const getTspBadgeByService = ({ showVouchersForm, tspUrl }: GetTspBadgesByServiceArgs) => {
  if (!showVouchersForm) {
    return profitableOfferBadge
  }

  if (tspUrl === 'genshin') {
    return profitableOfferBadge
  }

  if (tspUrl === 'pubg-pc') {
    return newServiceBadge
  }

  return officialPartnerBadge
}
